import { FC, useCallback } from 'react';
import {
  Conditional,
  DismissAllConfirmationBanner
} from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { Notification } from 'services/notifications/types';
import { dismissNotifications } from 'services/notifications/actions';
import { setSessionStorage } from '@cat-ecom/common/utils/storageUtils';

interface NotificationDismissBannerProps {
  showDismissAllBanner: boolean;
  resultPerPage: Array<Notification>;
  handleRefresh: () => void;
  handleConfirmationBannerCancel: () => void;
}

export const NotificationDismissBanner: FC<NotificationDismissBannerProps> = ({
  showDismissAllBanner,
  resultPerPage,
  handleRefresh,
  handleConfirmationBannerCancel
}) => {
  const t = useTranslations();

  const handleDismissAll = useCallback(async () => {
    try {
      const notificationsToDismiss: Notification[] = resultPerPage.map(
        (notification) => ({
          ...notification,
          isDismissed: true,
          isRead: true
        })
      );
      const { status } = await dismissNotifications(notificationsToDismiss);

      setSessionStorage('dismiss-all-feedback', status);
      handleRefresh();
    } catch (err) {
      throw new Error(err);
    }
  }, [resultPerPage, handleRefresh]);

  return (
    <Conditional test={showDismissAllBanner}>
      <DismissAllConfirmationBanner
        handleConfirmationBannerCancel={handleConfirmationBannerCancel}
        handleConfirmationBannerContinue={handleDismissAll}
        CANCEL={t('CANCEL')}
        DISMISS_ALL={t('DISMISS_ALL_NOTIFICATIONS')}
        NOTIFICATIONS_DISMISS_ALL_PAGE={t('NOTIFICATIONS_DISMISS_ALL_PAGE')}
      />
    </Conditional>
  );
};
